import { DefaultButton } from "@fluentui/react";
import { SwitchToProductionDialog } from "./SwitchToProductionDialog";
import { useState } from "react";
import { CustomerService } from "../../../../ApplicationCode/Customer/CustomerService";
import { MessageType, ToastService } from "../../../../Core/Toast/ToastService";
import { Customer } from "../../../../Model/CustomerModels";
import { switchButtonStyles } from "../Styles/SwitchToProductionDialogStyles";

export interface ISwitchToProductionDialogProps {
    customer: Customer;
    handleRedirectToShop: () => void;
    onSwitchSuccess: () => void;
}

export const SwitchToProduction: React.FC<ISwitchToProductionDialogProps> = (props: ISwitchToProductionDialogProps) => {
    const [saveInProgress, setSaveInProgress] = useState<boolean>(false);
    const [dialogHidden, setDialogHidden] = useState<boolean>(true);
    const [activeCustomer] = useState<string[]>(["50", "60", "70", "80"]);

    const handleSwitchToProductionAction = () => {
        if(props.customer.statusCode === "30")
            props.handleRedirectToShop();
        else if (activeCustomer.includes(props.customer.statusCode))
            setDialogHidden(false);
    }

    const handleSwitchToProduction = () => {
        setSaveInProgress(true);
        
        const customerService: CustomerService = new CustomerService();
        customerService.handleSwitchCustomerToProductionEnvironment(props.customer).then(() => {
            setDialogHidden(true);
            props.onSwitchSuccess();
        })
        .catch((error) => {
            setDialogHidden(true);
            setSaveInProgress(false);
            ToastService.showMessage(MessageType.Error, error.message);
        });
    };

    return (
        <>
            <DefaultButton 
                iconProps={{ iconName: "Unlock" }}
                styles={switchButtonStyles}
                onClick={() => handleSwitchToProductionAction()}
            >
                {CustomerService.translate("switchProductionButton")}
            </DefaultButton>
            <SwitchToProductionDialog 
                hidden={dialogHidden}
                saveInProgress={saveInProgress}
                onSuccess={() => handleSwitchToProduction()}
                onDismiss={() => setDialogHidden(true)}
            />
        </>
    );
};